import { render, staticRenderFns } from "./spirometry.vue?vue&type=template&id=5faba9ec&scoped=true&"
import script from "./spirometry.vue?vue&type=script&lang=js&"
export * from "./spirometry.vue?vue&type=script&lang=js&"
import style0 from "./spirometry.vue?vue&type=style&index=0&id=5faba9ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faba9ec",
  null
  
)

export default component.exports